import styled from "styled-components";

export const HeroWrapper = styled.section`
  min-height: 28px;
  border-bottom-left-radius: 180px;
  border-bottom-right-radius: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const HeroTitle = styled.h1`
  color: white;
  font-size: 38px;
  font-weight: 700;
  line-height: 1.15;
  max-width: 1100px;
  padding-inline: 20px;

  @media (max-width: 768px) {
    font-size: clamp(26px, 8vw, 38px);
  }
`;

export const HeroSubtitle = styled.p`
  color: #ffffff;
  font-size: 24px;
  margin-top: 24px;
  font-weight: 100;

  @media (max-width: 768px) {
    margin-top: 14px;
    font-size: clamp(16px, 5vw, 24px);
  }
`;
